<mat-card>
  <mat-card-header>
    <div mat-card-avatar><i class="fa fa-list fa-2x"></i></div>
    <mat-card-title>{{ title }}</mat-card-title>
    <mat-card-subtitle>{{ subtitle }}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content *ngIf="!loading">
    <ngx-crud-manager
        [clone]="true"
        [service]="additionalsService"
        [itemTemplate]="itemTemplate"
        [formTemplate]="formTemplate"
        [formGroup]="form"
    >
      <ng-template #itemTemplate let-item>
        <div tabindex="0" class="click" (keyup)="select(item)" (click)="select(item)"><i class="fa fa-plus"></i> {{item.name}} &nbsp; <b>({{ item.price | money }})</b></div>
      </ng-template>
      <ng-template #formTemplate let-fform="form" let-value="value">
        <form [formGroup]="fform">
          <mat-form-field>
            <mat-label>Nombre</mat-label>
            <input matInput formControlName="name" autocomplete="off">
          </mat-form-field>
          <div>
            <mat-label>{{hiddenInputTitle}} <i class="fa fa-question-circle" [matTooltip]="hiddenInputTooltipMessage"></i></mat-label>
            <mat-checkbox formControlName="hidden" id="hidden" />
          </div>
          @if (!value) {
            <mat-form-field>
              <mat-label>Precio</mat-label>
              <input matInput currencyMask formControlName="amount" autocomplete="off">
            </mat-form-field>
          }
        </form>
      </ng-template>
    </ngx-crud-manager>
  </mat-card-content>
</mat-card>
